<template>
    <custom-widget-form
        v-if="widget"
        :title="$t('custom_widgets.edit_custom_widget')"
        :id-site="idSite"
        :current-widget="widget"
        :save="save"
    ></custom-widget-form>
</template>

<script>
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import CustomWidgetForm from '@/vue/components/shared/custom-widgets/CustomWidgetForm';
import { ngInject } from '@/vue/decorators/angular-interop';

@Component({
    components: { CustomWidgetForm },
})
export default class EditCustomWidgetForm extends Vue {
    @Prop()
    idSite;
    @Prop()
    idCustomWidget;

    @ngInject()
    ApiService;

    widget = null;

    @Watch('idCustomWidget', { immediate: true })
    async loadWidget() {
        if (!this.idCustomWidget) return;
        const idBefore = this.idCustomWidget;
        const widget = (
            await this.ApiService.call2(
                `/installations/${this.idSite}/custom-widget?idCustomWidget=${this.idCustomWidget}`,
                {},
                { method: 'GET', onApiError: this.redirectToAdvanced },
            )
        ).data.widget;
        if (idBefore !== this.idCustomWidget) return;
        if (!widget || !widget.idCustomWidget) this.redirectToAdvanced();
        this.widget = widget;
    }

    async save(payload) {
        payload.idCustomWidget = this.idCustomWidget;
        return this.ApiService.call2(`/installations/${this.idSite}/custom-widget`, payload, {
            method: 'PATCH',
        });
    }

    redirectToAdvanced() {
        this.$router.push('base.installation.advanced', { id: this.idSite });
    }
}
</script>
